const apiState = {
  earning_potential_data: {
    data: [],
    isFetching: false,
    noDataForCity: false
  },
  locationData: {
    isFetching: false,
    location: {}
  },
  propertyData: {
    isFetching: false,
    data: {}
  },
  signUpData: {
    isFetching: false,
    data: {},
    errorMessage: ''
  },
  loginData: {
    isFetching: false,
    data: {},
    errorMessage: '',
    isFetchingTwo: false
  },
  otpData: {
    isFetching: false,
    data: {},
    errorMessage: ''
  },
  propertyGenOtpData:{
    data:{}
  }
};

export default apiState;
